module.exports = __webpack_public_path__ + "static/media/Trash.0e65c89f.svg";